import { ArticleStatusEnum } from "../enums/article";
import { EngineEnum } from "../enums/engine";
import { ImageEngineEnum } from "../enums/imageEngine";
import { SourceEnum } from "../enums/template";

export const ArticleStatusMap = {
  [ArticleStatusEnum.GENERATING]: "Generating",
  [ArticleStatusEnum.COMPLETED]: "Completed",
  [ArticleStatusEnum.ERROR]: "Error",
};

export const ArticleStatusColorMap = {
  [ArticleStatusEnum.GENERATING]: "#2563eb",
  [ArticleStatusEnum.COMPLETED]: "#22c55e",
  [ArticleStatusEnum.ERROR]: "#dc2626",
};

export interface ArticleProps {
  articleId: string;
  templateId: string;
  templateName: string;
  mediaUrl: string;
  s3TranscriptionUrl: string;
  s3ImageUrl: string;
  s3ArticleUrl: string;
  title: string;
  postedUrl: string;
  postedAt: string;
  articleSettingName: string;
  articleWordCount: number;
  createdAt: string;
  generateError: string;
  isAutoRun: boolean;
  articleStatusId: ArticleStatusEnum;
  sourceId: SourceEnum;
  tokensUsed: number;
  engineId?: EngineEnum;
  imageEngineId?: ImageEngineEnum;
  accountTagName?: string;
}
